<template>
  <div id="outer-container">
    <Slideshow/>
    <News class="contents news border"/>
    <Overview class="contents overview"/>
  </div>
</template>

<script>
import Slideshow from '@/components/Widgets/Slideshow.vue';
import News from '@/components/Home/News.vue';
import Overview from '@/components/Home/Overview.vue';

export default {
  components: {
    News,
    Overview,
    Slideshow,
  },
};
</script>

<style lang="scss" scoped>
.contents {
  margin: 50px 10px;
  &.news {
    margin: 0 10px 50px 10px;
  }
  &.overview {
    margin-bottom: 70px;
  }
  &.border {
    border-bottom: solid 2px $primary2;;
  }
}

@media (min-width: $mobile-vw) {
  .contents {
    max-width: $content-vw;
    margin: 150px auto;
    &.news {
      margin: 0px  auto 150px  auto;
    }
    &.overview {
      margin-bottom: 260px;
    }
    &.border {
      border-bottom: none;
    }
  }
}

@media (min-width: $mobile-vw + 1) and (max-width: $pc-vw) {
  .contents {
    margin-left: 260px !important;
  }
}
</style>